import { Alert, Box, Button, Typography } from '@mui/material';
import Paper from 'components/paper';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class OfdErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: Props): void {
    // Auto-recover on subtree updates so transient first-render errors do not get latched.
    if (this.state.hasError && prevProps.children !== this.props.children) {
      this.setState({ hasError: false });
    }
  }

  private handleRecoverView = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Paper transparent sx={{ p: 6 }}>
          <Box maxWidth={900}>
            <Alert
              severity="error"
              action={
                <Button color="inherit" size="small" onClick={this.handleRecoverView}>
                  <FormattedMessage id={'orderFeed.ofdMySupplyPlan.recoverView'} />
                </Button>
              }>
              <Typography variant="body1" fontWeight={700}>
                <FormattedMessage id={'orderFeed.ofdMySupplyPlan.viewTemporarilyUnavailable'} />
              </Typography>
              <Typography variant="body2">
                <FormattedMessage id={'orderFeed.ofdMySupplyPlan.settingsUnavailableMessage'} />
              </Typography>
            </Alert>
          </Box>
        </Paper>
      );
    }

    return this.props.children;
  }
}

export default OfdErrorBoundary;
